import React from "react";

import { ChartCollectionData } from "../../../../models/ChartCollectionData";
import { ChartButton } from "../../../Common/ChartButton";

import "./styles.scss";

export interface IFacilityDetailsAnalysisChartSelectProps {
  chartCollections: ChartCollectionData[];
  selectedChartIndex: number;
  onSelectChart: (chartId: number) => void;
}

export const FacilityDetailsAnalysisChartSelect: React.FunctionComponent<
  IFacilityDetailsAnalysisChartSelectProps
> = (props) => {
  const { selectedChartIndex, onSelectChart, chartCollections } = props;

  const handleClick = (id: number) => {
    onSelectChart(id);
  };

  return (
    <div className="chart-select-container">
      {chartCollections?.map((item, index) => (
        <ChartButton
          key={item.id}
          onClick={() => handleClick(index)}
          chartCollectionData={item}
          isActive={selectedChartIndex === index}
        />
      ))}
    </div>
  );
};
